import { KEYBOARD_SHORTCUTS } from '../constants/KEYBOARD_SHORTCUTS';
export const isKeyboardShortcut = event => {
  if (!event) {
    return {
      isValidShortcut: false,
      isGlobal: false
    };
  }
  let isGlobal = false;
  const isValidShortcut = KEYBOARD_SHORTCUTS.some(sc => {
    const isShortcut = sc.altKey === event.altKey && sc.ctrlKey === event.ctrlKey && sc.metaKey === event.metaKey && sc.shiftKey === event.shiftKey && sc.key === event.key;
    isGlobal = sc.isGlobal;
    return isShortcut;
  });
  return {
    isValidShortcut,
    isGlobal
  };
};